<template>
   <div class="banner">
		<img :src="bannerUrl?bannerUrl:bannerUrlDefault" alt="麒麟遨天 携手共测"/>
	</div>
</template>
<script>
import { post } from '@/units/request.js'
export default {
    name: '',
	data(){
		return{
			bannerUrl: '',
			bannerUrlDefault: require('@/assets/banner.png')
		}
	},
	methods:{
		//获取当前活动信息
		async getActiveInfo(){
			let url = 'v1/activity/getIndexActivity'
			let param = {}
			const res = await post(url, param)
			if(res.data.code==200) {
				let entity = res.data.entity
				this.activeInfo = entity
				this.bannerUrl = entity.bannerUrl
				localStorage.setItem('activeInfo', JSON.stringify(entity))
			} else {
				this.$message.error(res.data.msg)
			}
		}
	},
	created(){
		let activeInfo = localStorage.getItem('activeInfo')
		if(activeInfo!=null){
			activeInfo = JSON.parse(activeInfo)
			this.bannerUrl = activeInfo.bannerUrl
		} else {
			this.getActiveInfo()
		}
	}
}
</script>
<style scoped>
   .banner{
        text-align: center;
        position: relative;
		min-width: 1200px;
    }
    .banner img{
        max-width: 1920px;
        width: 100%;
        max-height: 650px
    }
</style>
